<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'pendingApproveDetailDialog',
  mixins: [snackbarMixin],
  props: {
    isCreateMode: {
      type: Boolean,
    },
    item: {
      type: Object,
      default: Object,
    },
  },
  data() {
    return {
      isLoading: false,
      visible: false,
      hasError: false,
      formData: {},
      pdfBlob: null,
    };
  },
  computed: {
    ...mapGetters('pendingApproveDetail', ['singularName']),
  },
  created() {
      this.formData = Object.assign({}, this.item);
  },
  mounted() {
    this.visible = true;
    this.initializeData();
  },
  beforeDestroy() {
    this.visible = false;
  },
  methods: {
    ...mapActions('odemeTalep',['getDetail', 'reject', 'approve', 'viewFile2']),
    ...mapMutations('odemeTalep', ['getList']),
    fetchData() {
      this.isLoading = true;
      this.getDetail(this.formData.pfaaliyet)
        .then((data) => {
          this.item = data.data;
          this.isInitialized = true;
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    rejectRecord(){
      this.isLoading = true;
      this.reject(this.item.pfaaliyet)
        .then(() => {
          this.showSuccessMessage(`${this.item.pfaaliyet} numaları bekleyen ödeme talebi reddedilmiştir.`);
          this.$emit('refresh');
        })
        .catch((err) => {
          this.showErrorMessage(err.response && err.response.data);
        })
        .finally(() => {
          this.isDeleting = false;
          this.isLoading = false;
          this.close();
        });
    },
    approveRecord() {
      this.isDeleting = true;
      this.isLoading = true;
      this.approve(this.item.pfaaliyet)
        .then(() => {
          this.showSuccessMessage(`${this.item.pfaaliyet} numaralı ödeme talebi onaylanmıştır.`);
          this.$emit('refresh');
        })
        .catch((err) => {
          this.showErrorMessage(err.response && err.response.data);
        })
        .finally(() => {
          this.isDeleting = false;
          this.isLoading = false;
          this.close();
        });
    },
    getFileName(filePath) {
      // Dosya yolunu "/" ile bölelim ve son parçayı (dosya adını) döndürelim
      const pathSegments = filePath.split('\\');
      return pathSegments[pathSegments.length - 1];  // Son parçayı alıyoruz, yani dosya adını
    },
    viewFile(filePath){
      this.viewFile2(filePath)
        .then((response) => {

          // Dosya uzantısını al
          const extension = filePath.split('.').pop().toLowerCase();
          const fileName = filePath.split('/').pop();

           // MIME tipi haritası
          const mimeMap = {
            pdf: 'application/pdf',
            doc: 'application/msword',
            docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            xls: 'application/vnd.ms-excel',
            xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          };

          const mimeType = mimeMap[extension] || 'application/octet-stream';

          // Blob oluştur
          const blob = new Blob([response.data], { type: mimeType });
          this.prepareDownload(blob, fileName, extension);

          // this.$emit('refresh');
        })
        .catch((err) => {
          this.showErrorMessage(err.response && err.response.data);
        })
        .finally(() => {
          this.isDeleting = false;
          this.isLoading = false;
          // this.close();
        });
    },
    prepareDownload(blob, fileName, extension) {
      const url = URL.createObjectURL(blob);

      // Eğer PDF ise tarayıcıda göster
      if (extension === 'pdf') {
        // window.open(url, '_blank');
        this.prepareDownloadForPdf(blob);
      } 
      // Word veya Excel ise otomatik indir
      else if (['doc', 'docx', 'xls', 'xlsx'].includes(extension)) {
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } 
      // Diğer formatlar için genel indirme davranışı
      else {
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      // Belleği temizle
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    },


    prepareDownloadForPdf(blob) {
      // Bu yöntem gerekli blob URL'yi hazırlamak için kullanılabilir
      // Örneğin bir indirme bağlantısı oluşturmak gibi.
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', 'document.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    },
    
    initializeData() {
      this.isLoading = true;
      Promise.all([this.getDetail(this.formData.pfaaliyet)])
        .then(([detail]) => {
          this.item = detail.data;
          this.isInitialized = true;
          this.isLoading = false;
        }, () => {
          this.hasError = true;
          this.isLoading = false;
        });
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible" persistent max-width="1080px">
    <v-card>
      <v-card-title>
        {{item.projeAdi}} - {{item.projeKodu}}
      </v-card-title>
      <v-flex xs12 style="margin-left:10px">
        {{ item.konu }}
        <b>Faaliyet Kodu:</b> {{ item.pfaaliyet }}
        <b>Talep No:</b> {{ item.talepNo }}
      </v-flex>

      <div class="container" style="background-color:rgb(229 231 235)" >
        <div class="row">
          <div class="col">
            <b>Cari:</b> {{ item.cari }}
          </div> 
        </div>
        <div class="row">
          <div class="col">
            <b>Fatura No:</b> {{ item.faturaNo }}
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b>Ödeme Açıklaması:</b> {{ item.odemeAciklamasi }}
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b>Ödeme Tarihi:</b> {{ item.odemeTarihi }}
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b>Ödeme Türü:</b> {{ item.odemeTuru }}
          </div>
        </div>
        <div class="row">
          <div class="col">  
            <b>Ödemeyi Yapacak Firma:</b> {{ item.odemeyiYapacakFirma }}
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b>Talebi Yapan Kullanıcı:</b> {{ item.talebiYapanKullanici }}
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b>Talep Tarihi:</b> {{ item.talepTarihi }}
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b>Tutar:</b> {{ item.tutar|toCurrency }} {{ item.doviz }} <b>Tutar Türk Lirası:</b> {{ item.tutarTRL|toCurrency }} TRL 
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b>Bütçe Yeri:</b> {{ item.butce_Yeri }} 
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div class="col-6" style="background-color:rgb(167 243 208)">
              <b>Birinci Seviye Onay:</b> {{ item.birSeviyeOnay }}
              <br />
              <b>Birinci Seviye Onaylayacak:</b> {{ item.birSeviyeOnaylacak }}
              <br />
              <b>Birinci Seviye Onaylayan:</b> {{ item.birSeviyeOnaylayan }}
          </div>
          <div class="col-6" style="background-color:rgb(229 231 235)">
              <b>İkinci Seviye Onay:</b> {{ item.ikiSeviyeOnay }}
              <br />
              <b>İkinci Seviye Onaylayacak:</b> {{ item.ikiSeviyeOnaylacak }}
              <br />
              <b>İkinci Seviye Onaylayan:</b> {{ item.ikiSeviyeOnaylayan }}
              <br />
          </div>
        </div>
      </div>
      <div class="container" v-if="formData.activityAttachments && formData.activityAttachments.length > 0">
        <div class="row">
          <div class="col-12">
            <div v-for="(document, index) in formData.activityAttachments" :key="index" class="d-flex align-center">
              <v-flex xs7 md7 py-0 class="d-flex align-center">
                EK &nbsp;
                <v-btn @click="viewFile(document.solelink)" style="align-self: right;">{{ $t('viewUploadedForm') }}</v-btn>
              </v-flex>
           </div>
          </div>
        </div>
      </div>

      <v-card-actions>
        <v-spacer />
        <v-btn :loading="isLoading" @click="rejectRecord" color="red lighten-3" dark>
            Reddet
        </v-btn>
        <v-btn :loading="isLoading" @click="approveRecord" color="green lighten-3" dark>
        Onayla
        </v-btn>
        <v-btn color="red lighten-3" dark @click="close">
          Kapat
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
